import { RawLink } from '@/shared/ui/RawLink'
import { Box, Typography, useTheme } from '@mui/material'
import { TopMenuButtonProps } from '@/types/topmenu/TopMenuButton'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppStore } from '../store'
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation'
import { isSmartTV } from '@/shared/lib'

const TopMenuButton = ({
    onClickFunction,
    buttonText,
    buttonIcon,
    active,
    destination,
    isDisabled,
    customIconStyle,
    focusKey,
}: TopMenuButtonProps) => {
    const theme = useTheme()

    const { setPreviousPage } = useAppStore()
    const location = useLocation()
    const navigate = useNavigate()

    const handleButtonClick = () => {
        onClickFunction()
        navigate(destination)
        setPreviousPage(location.pathname)
    }
    const { ref, focused } = useFocusable({
        focusable: true,
        focusKey,
        forceFocus: true,

        onEnterPress: () => {
            if (!isDisabled) handleButtonClick()
        },
    })

    const buttonStyle = {
        maxWidth: '86px',
        width: { xs: '100%', md: '100vw' },
        height: '34px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '20px',
        border: focused && isSmartTV() ? '2px solid red' : '',
        '&:hover': { cursor: !isDisabled ? 'pointer' : 'default' },
    }

    const iconStyle = {
        display: 'inline',
    }

    const typographyStyle = {
        typography: 'label4',
        color: () =>
            active && !isDisabled ? `${theme.palette.primary.main}` : 'none',
    }

    return (
        <RawLink to={destination} isDisabled={isDisabled}>
            <Box
                ref={ref}
                data-testid="top-menu-button"
                sx={buttonStyle}
                onClick={() => {
                    if (!isDisabled) handleButtonClick()
                }}>
                <Box sx={{ ...iconStyle, ...customIconStyle }}>
                    {buttonIcon}
                </Box>
                <Typography component="span" sx={typographyStyle} color="white">
                    {buttonText}
                </Typography>
            </Box>
        </RawLink>
    )
}

export { TopMenuButton }
